import useFetchProvidedJobPost from '../api/useFetchProvidedJobPost';
import ProvidedJobPostsForm from '../components/ProvidedJobPostsForm';
import { useSetBreadcrumbTitle } from '@/hooks/useBreadcrumb';

type Props = {
  id: string;
};

export default function ProvidedJobPostsEditTemplate({ id }: Props) {
  const { data, isLoading } = useFetchProvidedJobPost(Number(id));

  // データ取得後にパンくず情報を設定
  useSetBreadcrumbTitle(data?.title);

  return (
    <div>
      {!isLoading && (
        <section className="p-6 pt-3">
          <ProvidedJobPostsForm formType="edit" providedJobPostData={data} />
        </section>
      )}
    </div>
  );
}
